var icon = require('vue-svgicon')
icon.register({
  'ks-icon-filter': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M78 100.76a4.49 4.49 0 0 1-1.36 3.88 4.65 4.65 0 0 1-6.57 0L51.36 85.93A4.63 4.63 0 0 1 50 82.05V58.16l-22.35-28.6a4.67 4.67 0 0 1 .8-6.53 4.86 4.86 0 0 1 2.89-1h65.32a4.86 4.86 0 0 1 2.89 1 4.67 4.67 0 0 1 .8 6.53L78 58.16v42.6M40.86 31.33l18.47 23.61V80.7l9.34 9.3V54.9l18.47-23.57z"/>'
  }
})
